import { NavLink } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

const Link = ({ to, state, end = false, label, icon, className }) => (
  <NavLink
    to={to}
    state={state}
    end={end}
    className={({ isActive }) => twMerge(
      `w-full sm:w-fit flex flex-row justify-center items-center h-full p-1.5 outline-none text-muted-foreground font-medium text-sm ${className}`,
      isActive
        ? 'border-b border-foreground text-foreground'
        : 'border-b border-transparent'
    )}
  >
    {icon}
    <span className='ml-2'>
      {label}
    </span>
  </NavLink>
)

export default Link
